/**
 * @flow
 * @relayHash 366fec3cc74f9ba590d95ad40c60d8be
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BillingStatus = "PAYMENT_ISSUE" | "PLAN_ACTIVE" | "TRIAL_ACTIVE" | "TRIAL_EXPIRED_NO_PAYMENT";
export type BillingQueryVariables = {||};
export type BillingQueryResponse = {|
  +billingDetails: ?{|
    +id: string,
    +status: BillingStatus,
    +productName: string,
    +planName: string,
    +planDescription: string,
    +planInterval: string,
    +planCostUSD: number,
    +totalSeats: number,
    +active: boolean,
    +trialActive: boolean,
    +trialDaysRemaining: number,
    +fullName: string,
    +cardType: ?string,
    +cardLast4: ?string,
    +cardExpMonth: ?number,
    +cardExpYear: ?number,
    +cardAddressStatus: ?string,
    +cardZipStatus: ?string,
    +cardCVCStatus: ?string,
    +addressLine1: string,
    +addressLine2: string,
    +city: string,
    +state: string,
    +zip: string,
    +country: string,
  |},
  +billingInvoices: $ReadOnlyArray<{|
    +id: string,
    +paid: boolean,
    +periodStart: any,
    +periodEnd: any,
    +amountUSD: number,
    +amountPaidUSD: number,
    +amountOutstandingUSD: number,
    +attempts: number,
    +invoicePDFUrl: ?string,
    +invoiceUrl: ?string,
  |}>,
|};
export type BillingQuery = {|
  variables: BillingQueryVariables,
  response: BillingQueryResponse,
|};
*/


/*
query BillingQuery {
  billingDetails {
    id
    status
    productName
    planName
    planDescription
    planInterval
    planCostUSD
    totalSeats
    active
    trialActive
    trialDaysRemaining
    fullName
    cardType
    cardLast4
    cardExpMonth
    cardExpYear
    cardAddressStatus
    cardZipStatus
    cardCVCStatus
    addressLine1
    addressLine2
    city
    state
    zip
    country
  }
  billingInvoices {
    id
    paid
    periodStart
    periodEnd
    amountUSD
    amountPaidUSD
    amountOutstandingUSD
    attempts
    invoicePDFUrl
    invoiceUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "billingDetails",
    "storageKey": null,
    "args": null,
    "concreteType": "BillingDetails",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "productName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "planName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "planDescription",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "planInterval",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "planCostUSD",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalSeats",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "active",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "trialActive",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "trialDaysRemaining",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fullName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardType",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardLast4",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardExpMonth",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardExpYear",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardAddressStatus",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardZipStatus",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cardCVCStatus",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLine1",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "addressLine2",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "city",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "state",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "zip",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "country",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "billingInvoices",
    "storageKey": null,
    "args": null,
    "concreteType": "BillingInvoice",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "paid",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "periodStart",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "periodEnd",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "amountUSD",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "amountPaidUSD",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "amountOutstandingUSD",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "attempts",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoicePDFUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "invoiceUrl",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "BillingQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "BillingQuery",
    "argumentDefinitions": [],
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "BillingQuery",
    "id": null,
    "text": "query BillingQuery {\n  billingDetails {\n    id\n    status\n    productName\n    planName\n    planDescription\n    planInterval\n    planCostUSD\n    totalSeats\n    active\n    trialActive\n    trialDaysRemaining\n    fullName\n    cardType\n    cardLast4\n    cardExpMonth\n    cardExpYear\n    cardAddressStatus\n    cardZipStatus\n    cardCVCStatus\n    addressLine1\n    addressLine2\n    city\n    state\n    zip\n    country\n  }\n  billingInvoices {\n    id\n    paid\n    periodStart\n    periodEnd\n    amountUSD\n    amountPaidUSD\n    amountOutstandingUSD\n    attempts\n    invoicePDFUrl\n    invoiceUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '588195cebd9db6835448c611f1d58af1';
module.exports = node;
